import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user/azagent2/_work/1/s/apps/dashboard/src/app/[locale]/LocaleLangSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user/azagent2/_work/1/s/apps/dashboard/src/app/providers/intlProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/user/azagent2/_work/1/s/node_modules/react-hot-toast/dist/index.mjs");
